<template>
  <div id="Laddress">
    <div class="laddressFirst">
      <div class="laddressFirstLeft">发票抬头</div>
      <div class="laddressFirstBtn" @click="newinvioce()">新增</div>
    </div>
      <Table :columns="columns1" :data="data1" class="widthAuto">
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <i-switch
              true-color="#3562E8"
              v-model="row.isDefault"
              @on-change="handleChang(row, index)"
            />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <div>
            <span class="bianji" @click="bianji(row, index)">编辑</span>
            <span class="del" @click="del(row)">删除</span>
          </div>
        </template>
      </Table>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  getInvoice,
  postInvoiceisDefaultIsDefault,
} from "../../../network/LPersonal";
import { delInvoice } from "../../../network/order2";
export default {
  data() {
    return {
      columns1: [
        {
          title: "发票抬头",
          key: "invoiceRise",
        },
        {
          title: "纳税人识别号",
          key: "identifyNumber",
        },
        {
          title: "默认状态",
          slot: "action",
          width: 100,
        },
        {
          title: "操作",
          slot: "action1",
          width: 130,
        },
      ],
      data1: [],
    };
  },
  created() {
    this.get();
    this.$emit("editPage", "账户资料", "发票抬头");
  },
  activated(){
    this.$emit("editPage", "账户资料", "发票抬头");
  },
  methods: {
    bianji(row, index) {
      console.log(row)
      this.$router.push({
        name: "newinvoice1",
        query: {
          data: encodeURIComponent(JSON.stringify(row)),
        },
      });
    },
    del(row) {
      console.log(row);
      delInvoice(row.id).then((r) => {
        console.log(r);
        if (r.data.code == 200) {
          this.$Message.success(r.data.msg);
          this.get();
        }
      });
    },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    newinvioce() {
      this.$router.push("/newinvoice");
    },
    handleChang(status) {
      // this.$Message.info('开关状态：' + status);
      console.log(status);
      let form = {
        invoiceId: status.id,
        isDefault: status.isDefault == true ? 2 : 1,
      };

      postInvoiceisDefaultIsDefault(form).then((res) => {
        console.log(res, "默认发票修改");
        console.log(form.isDefault);
        if (res.data.code == 200) {
          this.$message.success("修改成功");
          this.get()
        }
      });
    },
    get() {
      getInvoice({ userId: this.Get("userId") }).then((res) => {
        console.log(res);
        res.data.data.forEach((element, i) => {
          // if(element.isDefault){
          res.data.data[i].isDefault = element.isDefault == 2 ? true : false;
          // }
        });
        this.data1 = res.data.data;
      });
    },
  },
};
</script>

<style>
@import url("../../../assets/css/liucss/address.css");
</style>